var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C18.9466 16 21.3333 13.6133 21.3333 10.6667C21.3333 7.72001 18.9466 5.33334 16 5.33334C13.0533 5.33334 10.6666 7.72001 10.6666 10.6667C10.6666 13.6133 13.0533 16 16 16ZM16 18.6667C12.44 18.6667 5.33331 20.4533 5.33331 24V26.6667H26.6666V24C26.6666 20.4533 19.56 18.6667 16 18.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfil);
export default __webpack_public_path__ + "static/media/perfil.961d78ba531ea209cfbf56875b465c32.svg";
export { ForwardRef as ReactComponent };